import * as React from 'react';
import { Box, Typography } from '@mui/material';

import { FormWrapper, TopBorderPaper } from 'components';
import { AuthForgotPasswordForm } from 'forms';

interface AuthForgotPasswordPageProps {}

export const AuthForgotPasswordPage: React.FC<AuthForgotPasswordPageProps> = () => {
  return (
    <Box
      sx={{
        paddingX: 2,
        paddingTop: 3,
        paddingBottom: 8,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: 3,
        }}
      />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          minHeight: 400,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: (theme) => theme.breakpoints.values.sm,
            position: 'relative',
          }}
        >
          <TopBorderPaper>
            <FormWrapper>
              <Typography
                variant="h5"
                sx={{
                  marginBottom: 1,
                }}
              >
                Forgot Your Password?
              </Typography>

              <Typography
                color="textSecondary"
                variant="body2"
                sx={{
                  lineHeight: 1.5,
                  marginBottom: 6,
                }}
              >
                Enter an email to send your new password
              </Typography>

              <Box marginTop={6} maxWidth={600} marginX="auto">
                <AuthForgotPasswordForm />
              </Box>
            </FormWrapper>
          </TopBorderPaper>
        </Box>
      </Box>
    </Box>
  );
};
